import { List, ListItem } from 'palette/List';
import { useTranslation } from '@common/Hooks/useTranslation';
import latinize from '@helpers/latinize';
import { BrandsListItem } from './BrandsListItem';
import { FiltersListItemMobile as FiltersListItem } from './FiltersListItemMobile';

const removeDuplicateLetters = (letters, letter) => {
    if (letters.indexOf(letter) === -1) {
        letters.push(letter);
    }

    return letters;
};

const renderListItems = (filtersGroup, filterType) => {
    const ItemComponent = filterType === 'brand' ? BrandsListItem : FiltersListItem;

    return filtersGroup.map(filter => (
        filter.count > 0
            && (
                <ItemComponent
                    key={`${filter.name}-${filter.value}`}
                    item={filter}
                />
            )
    ));
};

export function FiltersListGrouped({
    filters,
    type,
    children,
    search = ''
}) {
    const translate = useTranslation();
    const labelKey = type === 'size' ? 'label' : 'name';

    const filterBySearch = (filter) => {
        if (search === '') {
            return filter;
        }

        const latinizedSearch = latinize(search).toLowerCase();
        const latinizedName = latinize(filter[labelKey]).toLowerCase();

        return latinizedName.indexOf(latinizedSearch) !== -1;
    };

    const firstLetter = item => item[labelKey].charAt(0).toUpperCase();

    const itemsPerLetter = (letter, items) => {
        const letterArray = items.filter(item => firstLetter(item) === letter);
        letterArray.key = letter;
        return letterArray;
    };

    const getFiltersGroups = () => {
        const items = filters.filter(filterBySearch);

        if (type === 'size') {
            return items.map(item => item.ranges);
        }

        if (['brand', 'tag-productseries'].includes(type)) {
            return items
                .filter(item => item.count > 0)
                .map(firstLetter)
                .reduce(removeDuplicateLetters, [])
                .map(letter => itemsPerLetter(letter, items));
        }

        return filters;
    };

    const filtersGroups = getFiltersGroups()
        .filter(filtersGroup => filtersGroup.filter(({ count }) => count > 0).length > 0);

    return (
        <>
            {search === '' && children}
            <div className="filters__list">
                {filtersGroups.map((filtersGroup, index) => {
                    const key = filtersGroup.key || translate(filters[index].label);

                    return (
                        <List key={key}>
                            <ListItem
                                label={key}
                                labelType="large-title"
                                verticalAlignment="bottom"
                            />
                            {renderListItems(filtersGroup, type)}
                        </List>
                    );
                })}
            </div>
        </>
    );
}
